import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal", "form", "idsField", "count", "optionRadio", "submit"]

  connect() {
    if (this.hasModalTarget) {
      this._handleModalHidden = this.reset.bind(this)
      this.modalTarget.addEventListener("hidden.bs.modal", this._handleModalHidden)
    }
  }

  disconnect() {
    if (this.hasModalTarget && this._handleModalHidden) {
      this.modalTarget.removeEventListener("hidden.bs.modal", this._handleModalHidden)
    }
  }

  open(event) {
    event.preventDefault()

    const selectedIds = this.selectedIds()
    if (selectedIds.length === 0) return

    if (this.hasIdsFieldTarget) {
      this.idsFieldTarget.value = selectedIds.join(",")
    }

    if (this.hasCountTarget) {
      const noun = selectedIds.length === 1 ? "course" : "courses"
      this.countTarget.textContent = `${selectedIds.length} ${noun}`
    }

    this.reset()
    Modal.getOrCreateInstance(this.modalTarget).show()
  }

  optionChanged() {
    if (!this.hasSubmitTarget) return

    this.submitTarget.disabled = !this.optionRadioTargets.some(radio => radio.checked)
  }

  reset() {
    this.optionRadioTargets.forEach(radio => { radio.checked = false })
    if (this.hasSubmitTarget) this.submitTarget.disabled = true
  }

  selectedIds() {
    return [...this.element.querySelectorAll('[data-bulk-select-target="checkbox"]:checked')]
      .filter(checkbox => !checkbox.closest("tr[hidden]"))
      .map(checkbox => checkbox.value)
  }
}
